// TODO: Currently only used in user-account-app and requires React Router v6.
// Can be moved to shared-hooks once it supports React Router v6.
import { useNavigate, useLocation } from "react-router-dom";

export const useReturnUrl = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getReturnUrl = () => {
    const params = new URLSearchParams(location.search);

    return params.get("returnUrl");
  };

  const redirectToReturnUrl = () => {
    const returnUrl = getReturnUrl();

    if (returnUrl) {
      navigate(returnUrl);
    }
  };

  const redirectWithReturnUrl = (pathname: string, returnPath: string) => {
    navigate({
      pathname,
      search: `?returnUrl=${encodeURIComponent(returnPath)}`,
    });
  };

  return {
    getReturnUrl,
    redirectToReturnUrl,
    redirectWithReturnUrl,
  };
};
